import { useEffect, useState } from 'react';
import cities_to_countries from '../lib/shared/timezones/cities_to_countries.json';

/**
 * Used to pull feature sets based on user-specific geolocation (not necessarily their set language).
 */
export default function useGeolocation(initialCountryCode?: string): {
  isUSA: boolean;
} {
  const countryCode = initialCountryCode;
  let _isUSA = true;

  // Exists and is not US
  if (countryCode && countryCode !== 'US') {
    _isUSA = false;
  }

  const [isUSA, setIsUSA] = useState(_isUSA);

  useEffect(() => {
    // Get approx location from browser timezone if no geolocation available
    if (!countryCode) {
      const [, city] = window.Intl.DateTimeFormat()
        .resolvedOptions()
        .timeZone.split('/');

      const country = (cities_to_countries as { [index: string]: string })[
        city
      ];

      if (isUSA === true && country !== 'United States') {
        setIsUSA(false);
      }
    }
  }, []);

  return { isUSA };
}
